import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createSlots as _createSlots, isRef as _isRef, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex align-center" };
const _hoisted_2 = { class: "d-flex" };
const _hoisted_3 = { class: "body2-text mt-2" };
import { computed, ref, watch, onMounted, nextTick, toRefs, } from 'vue';
import { parseGeocoder, trimTextField, onBlurTrimTextField, setLimitedByteText, } from '@/utils';
import { employeeTypeCode, salaryTypeCode, validationLimitingValue, } from '@/constants';
import { orderDetailDialogWidth } from '@/styles/export.module.scss';
import { i18n } from '@/locales';
import CardSection from '@/components/Common/CardSection.vue';
import InputRow from '@/components/Form/InputRow.vue';
import { typeData } from '@/constants/workerManagementList';
import AddressFormVM from '@/view-model/AddressFormVM';
import DialogHeader from '@/components/Dialog/DialogHeader.vue';
import { alertActionType } from '@/vuex-store/alert/actions';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { useModelWrapper, useNumberTypeModalWrapper, } from '@/utils/vueUtils';
import { convictionStatus } from '@/constants/convictionStatus';
import vuexStore from '@/vuex-store';
const changePostcodeLc = 'views.order_detail.order_detail_change_post_code.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WorkInfo',
    props: {
        lc: { default: '' },
        formRulesLc: { default: '' },
        formData: { default: () => ({}) },
        errorMessageData: { default: () => ({}) },
        formRules: { default: () => ({}) }
    },
    emits: ["setFormData", "setErrorMessageData"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { formRulesLc, formData, errorMessageData, } = toRefs(props);
        const { WORKER_NAME_MAX_BYTE, HUB_EMPLOYEE_NUMBER_MAX_BYTE, PHONE_MAX_LENGTH, WORKER_CREATE_MEMO_MAX_LENGTH, DEPOSIT_BAROMONEY_MAX_LENGTH, WITHDRAWAL_BANK_ACCOUNT_MAX_LENGTH, WITHDRAWAL_BANK_OWNER_MAX_LENGTH, ADDRESS_MAX_LENGTH, } = validationLimitingValue;
        const bankItems = vuexStore.getters['systemCode/bankItems'];
        // const { isPhoneExist: _isPhoneExist } = useWorkerAction([
        //   'isPhoneExist',
        // ]);
        // const { isHubEmployeeNumberExist: _isHubEmployeeNumberExist } = useWorkerAction([
        //   'isHubEmployeeNumberExist',
        // ]);
        // const { showError: _showErrorMessage } = useSnackbarAction([
        //   'showError',
        // ]);
        // const { confirm: _confirm } = useAlertAction([
        //   'confirm',
        // ]);
        const { 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        SPECIAL_EMPLOYMENT_INSURANCE_EXCLUSION, ...withoutSpecialEmploymentInsuranceExclusion } = employeeTypeCode;
        const employeeTypeOptions = Object.values(withoutSpecialEmploymentInsuranceExclusion);
        const salaryTypeOptions = Object.values(salaryTypeCode);
        const workerNameRef = ref(null);
        const noNeedConfirm = ref(false);
        const phoneRef = ref(null);
        const hubEmployeeNumberRef = ref(null);
        const postcodeDialogRef = ref(null);
        const isCheckedHubEmployeeNumberExistence = ref(false);
        const isCheckedPhoneExistence = ref(false);
        const isPostcodeDialogOpen = ref(false);
        const PostcodeData = ref('');
        const GeocoderData = ref('');
        const StatusData = ref('');
        const datePickerDialog = ref(false);
        const workerRegDateRef = ref('');
        const isCurrentAddressDisabled = ref(true);
        const formattedDepositBaromoneyComputed = useNumberTypeModalWrapper(formData.value, 'depositBaromoney', emit);
        const employeeTypeComputed = useModelWrapper(formData.value, 'employeeType', emit);
        const salaryTypeComputed = useModelWrapper(formData.value, 'salaryType', emit);
        const phoneComputed = useModelWrapper(formData.value, 'phone', emit);
        const telNumberComputed = useModelWrapper(formData.value, 'telNumber', emit);
        const workTimeOnComputed = useModelWrapper(formData.value, 'workTime.on', emit);
        const workTimeOffComputed = useModelWrapper(formData.value, 'workTime.off', emit);
        const memoComputed = useModelWrapper(formData, 'memo', emit);
        const withdrawalBankAccountComputed = useModelWrapper(formData, 'withdrawalBankAccount', emit);
        const withdrawalBankOwnerComputed = useModelWrapper(formData, 'withdrawalBankOwner', emit);
        const convictionStatusComputed = computed({
            get() {
                return formData.value.convictionStatus;
            },
            set(value) {
                emit('setFormData', 'convictionStatus', value);
            },
        });
        const workerNameComputed = computed({
            get() {
                return formData.value.name;
            },
            set(value) {
                const limitedText = setLimitedByteText(value, WORKER_NAME_MAX_BYTE, workerNameRef.value);
                emit('setFormData', 'name', limitedText);
            },
        });
        const hubEmployeeNumberComputed = computed({
            get() {
                return formData.value.hubEmployeeNumber;
            },
            set(value) {
                const limitedText = setLimitedByteText(value, HUB_EMPLOYEE_NUMBER_MAX_BYTE, hubEmployeeNumberRef.value);
                emit('setFormData', 'hubEmployeeNumber', limitedText);
            },
        });
        const currentAddress = computed({
            get() {
                if (formData.value.homeAddress) {
                    return formData.value.homeAddress;
                }
                return formData.value.addressFormData.formattedAddressBasedOfLi('full', false);
            },
            set(value) {
                if (!value) {
                    formData.value.addressFormData.setAddressFormData(new AddressFormVM({}));
                }
                emit('setFormData', 'homeAddress', value);
            },
        });
        // const detailAddress = useModelWrapper(formData, 'detailAddress', emit);
        const workerTypeComputed = computed(() => typeData[formData.value.type].text);
        const withdrawalBankCodeComputed = computed({
            get() {
                return formData.value.withdrawalBankCode;
            },
            set(value) {
                emit('setFormData', 'withdrawalBankCode', value);
            },
        });
        const handleEmployeeTypeConfirm = async () => {
            const isConfirm = await vuexStore.dispatch(alertActionType.confirm, {
                headerTitle: i18n.t('views.worker.common.confirm_change_employee_type_title'),
                bodyContentHtml: `<div> 선택한 고용형태의 라이더는 본사에서 특수고용직 고용보험 신고대상에서 제외됩니다.<br/>
          <span class="body1-text">* 사실과 다르게 설정할 경우, 라이더와 허브에 불이익이 발생 할 수 있습니다.</span></div>`,
            });
            return isConfirm;
        };
        const handleCheckHubEmployeeNumberExistence = async () => {
            try {
                const hubEmployeeNumberExist = await vuexStore
                    .dispatch('workerManagement/workerCreate/isHubEmployeeNumberExist', {
                    hubEmployeeNumber: formData.value.hubEmployeeNumber,
                });
                // 체크 완료 icon 보이기
                isCheckedHubEmployeeNumberExistence.value = true;
                if (!hubEmployeeNumberExist) {
                    return;
                }
                emit('setErrorMessageData', errorMessageData.value, 'hubEmployeeNumberExistence', i18n.t(`${formRulesLc.value}already_registered_value`, {
                    field: '사번',
                }));
            }
            catch (error) {
                // 체크 완료 icon 보이기
                isCheckedHubEmployeeNumberExistence.value = true;
                console.log('[WorkerCreate handleCheckHubEmployeeNumberExistence]', error);
                emit('setErrorMessageData', errorMessageData.value, 'hubEmployeeNumberExistence', i18n.t(`${formRulesLc.value}unknown_api_error`));
            }
        };
        const handleClickCheckPhoneExistence = async () => {
            try {
                const phoneExist = await vuexStore.dispatch('workerManagement/workerCreate/isPhoneExist', {
                    phone: formData.value.phone,
                });
                isCheckedPhoneExistence.value = true;
                console.log('[WorkerCreate handleClickCheckPhoneExistence]', phoneExist);
                if (!phoneExist) {
                    return;
                }
                emit('setErrorMessageData', errorMessageData.value, 'phoneExistence', i18n.t(`${formRulesLc.value}already_registered_value`, {
                    field: '단말기번호',
                }));
            }
            catch (error) {
                isCheckedPhoneExistence.value = true;
                console.log('[WorkerCreate handleClickCheckPhoneExistence]', error);
                emit('setErrorMessageData', errorMessageData.value, 'phoneExistence', i18n.t(`${formRulesLc.value}unknown_api_error`));
            }
        };
        const onBlurWorkerNameField = () => {
            onBlurTrimTextField('name', trimTextField(formData.value.name), emit);
        };
        const onBlurMemoField = () => {
            onBlurTrimTextField('memo', trimTextField(formData.value.memo), emit);
        };
        const onBlurDepositBaromoney = (value) => {
            if (!value) {
                emit('setFormData', 'depositBaromoney', 0);
            }
        };
        const onBlurWithdrawalBankOwnerField = () => {
            onBlurTrimTextField('withdrawalBankOwner', trimTextField(formData.value.withdrawalBankOwner), emit);
        };
        const onBlurHubEmployeeNumberField = async () => {
            onBlurTrimTextField('hubEmployeeNumber', trimTextField(formData.value.hubEmployeeNumber), emit);
            const isValid = await hubEmployeeNumberRef.value.validate();
            if (isValid.lenght === 0) {
                handleCheckHubEmployeeNumberExistence();
            }
        };
        const onBlurPhoneField = async () => {
            const isValid = await phoneRef.value.validate();
            if (isValid.length === 0) {
                // api 요청 후 res로 유효성 여부 판단 필요
                handleClickCheckPhoneExistence();
            }
        };
        const onBlurWorkTimeField = (fieldName) => {
            let temp = formData.value.workTime[fieldName];
            if (!temp) {
                temp = fieldName === 'on' ? '00:00' : '23:59';
            }
            emit('setFormData', `workTime.${fieldName}`, temp);
        };
        const resetPhoneExistenceSign = () => {
            isCheckedPhoneExistence.value = false;
            if (!errorMessageData.value.phoneExistence) {
                return;
            }
            emit('setErrorMessageData', errorMessageData.value, 'phoneExistence', '');
        };
        const resetHubEmployeeNumberExistenceSign = () => {
            isCheckedHubEmployeeNumberExistence.value = false;
            if (!errorMessageData.value.hubEmployeeNumberExistence) {
                return;
            }
            emit('setErrorMessageData', errorMessageData.value, 'hubEmployeeNumberExistence', '');
        };
        const handleClickPostcode = async () => {
            const GeocoderClass = GeocoderData.value;
            if (!GeocoderClass) {
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t(`${changePostcodeLc}kakao_map_error`),
                });
                return;
            }
            isPostcodeDialogOpen.value = true;
            await nextTick();
            const PostcodeClass = PostcodeData.value;
            new PostcodeClass({
                oncomplete: async (data) => {
                    const geocoder = new GeocoderClass();
                    geocoder.addressSearch(data.address, (result, status) => {
                        if (StatusData.value.OK === status) {
                            const { address, road_address: roadAddress, x, y, } = result[0];
                            currentAddress.value = '';
                            formData.value.addressFormData.setAddressFormData(parseGeocoder({
                                address,
                                roadAddress,
                                x,
                                y,
                            }));
                        }
                    });
                    isPostcodeDialogOpen.value = false;
                    isCurrentAddressDisabled.value = false;
                },
                width: orderDetailDialogWidth,
                height: 685,
            }).embed(postcodeDialogRef.value);
        };
        const handleClickCancelPostcode = () => {
            isPostcodeDialogOpen.value = false;
        };
        const handleClickPickerSubmit = () => {
            emit('setFormData', 'workerRegDate', workerRegDateRef.value);
            datePickerDialog.value = false;
        };
        watch(() => formData.value.employeeType, async (newValue, oldValue) => {
            // 컨펌창 노출 정책 관련 피그마 문서: https://www.figma.com/file/FaQ7BdPXD0codZs2fMjntK/%5B%EB%9D%BC%EC%9D%B4%EB%8D%94%5D-%EA%B4%80%EB%A6%AC-%E2%98%81%EF%B8%8F?type=design&node-id=3594-56950&mode=design&t=aAf33tqvHRnqXURz-4
            // 1) 컨펌창이 필요없는지 확인 (이전에 취소 선택했는지에 따라 컨펌여부 변경됨)
            if (noNeedConfirm.value) {
                noNeedConfirm.value = false;
                return;
            }
            // 2) 컨펌창이 나와야 하는 옵션인지 확인(컨펌창이 띄워질 필요없는 경우 선택값으로 설정 후 리턴)
            // index 1 = "SPECIAL"
            const showConfirmCode = Object.keys(employeeTypeCode)
                .filter((key) => key !== employeeTypeCode.SPECIAL.field);
            if (!showConfirmCode.includes(newValue)) {
                emit('setFormData', 'employeeType', newValue);
                return;
            }
            // 3) 컨펌 선택값에 따라 초기값 또는 선택값
            const isConfirmOk = await handleEmployeeTypeConfirm();
            if (!isConfirmOk) {
                emit('setFormData', 'employeeType', oldValue);
                // 취소선택으로 인한 이전 선택옵션에서는 컨펌창 필요없음
                noNeedConfirm.value = true;
            }
        });
        watch(() => formData.value.phone, () => {
            resetPhoneExistenceSign();
        });
        watch(() => formData.value.hubEmployeeNumber, () => {
            resetHubEmployeeNumberExistenceSign();
        });
        watch(() => currentAddress.value, (value) => {
            isCurrentAddressDisabled.value = !value;
        });
        onMounted(() => {
            const [, employeeTypeSecondOption,] = employeeTypeOptions;
            emit('setFormData', 'employeeType', employeeTypeSecondOption.value);
            const [, salaryTypeSecondOption,] = salaryTypeOptions;
            emit('setFormData', 'salaryType', salaryTypeSecondOption.value);
            workerRegDateRef.value = formData.value.workerRegDate;
            const { Postcode } = window.daum;
            PostcodeData.value = Postcode;
            if (window.kakao) {
                const { Geocoder, Status } = window.kakao.maps.services;
                GeocoderData.value = Geocoder;
                StatusData.value = Status;
            }
            else {
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t(`${changePostcodeLc}kakao_map_error`),
                });
            }
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
            const _component_vue_datepicker = _resolveComponent("vue-datepicker");
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(CardSection, {
                    title: _ctx.$t(`${_ctx.lc}employee_info`)
                }, {
                    default: _withCtx(() => [
                        _createCommentVNode(" 라이더명 "),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}worker_name`),
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    ref_key: "workerNameRef",
                                    ref: workerNameRef,
                                    modelValue: workerNameComputed.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((workerNameComputed).value = $event)),
                                    density: "compact",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    "validate-on": "blur",
                                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '이름' }),
                                    rules: _ctx.formRules.name.value,
                                    onBlur: onBlurWorkerNameField
                                }, null, 8 /* PROPS */, ["modelValue", "placeholder", "rules"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createCommentVNode(" 사번 "),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}hub_employee_number`),
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    ref_key: "hubEmployeeNumberRef",
                                    ref: hubEmployeeNumberRef,
                                    modelValue: hubEmployeeNumberComputed.value,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((hubEmployeeNumberComputed).value = $event)),
                                    density: "compact",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    "validate-on": "blur",
                                    "error-messages": _unref(errorMessageData).hubEmployeeNumberExistence,
                                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '사번' }),
                                    rules: _ctx.formRules.hubEmployeeNumber.value,
                                    onBlur: onBlurHubEmployeeNumberField
                                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                                    (isCheckedHubEmployeeNumberExistence.value)
                                        ? {
                                            name: "append-inner",
                                            fn: _withCtx(() => [
                                                (_unref(errorMessageData).hubEmployeeNumberExistence)
                                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                                        key: 0,
                                                        color: "red"
                                                    }, {
                                                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                                                            _createTextVNode(" mdi-close ")
                                                        ])),
                                                        _: 1 /* STABLE */,
                                                        __: [22]
                                                    }))
                                                    : (_openBlock(), _createBlock(_component_v_icon, {
                                                        key: 1,
                                                        color: "green"
                                                    }, {
                                                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                            _createTextVNode(" mdi-check ")
                                                        ])),
                                                        _: 1 /* STABLE */,
                                                        __: [23]
                                                    }))
                                            ]),
                                            key: "0"
                                        }
                                        : undefined
                                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "error-messages", "placeholder", "rules"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createCommentVNode(" 고용형태 "),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}worker_employee_type`),
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                    "item-title": "text",
                                    "item-value": "value",
                                    modelValue: _unref(employeeTypeComputed),
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_isRef(employeeTypeComputed) ? (employeeTypeComputed).value = $event : null)),
                                    items: _unref(employeeTypeOptions),
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "auto"
                                }, null, 8 /* PROPS */, ["modelValue", "items"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}salary_type`),
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                    "item-title": "text",
                                    "item-value": "value",
                                    modelValue: _unref(salaryTypeComputed),
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (_isRef(salaryTypeComputed) ? (salaryTypeComputed).value = $event : null)),
                                    items: _unref(salaryTypeOptions),
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "auto"
                                }, null, 8 /* PROPS */, ["modelValue", "items"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}phone`),
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    ref_key: "phoneRef",
                                    ref: phoneRef,
                                    modelValue: _unref(phoneComputed),
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (_isRef(phoneComputed) ? (phoneComputed).value = $event : null)),
                                    density: "compact",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    inputmode: "numeric",
                                    "validate-on": "blur",
                                    "error-messages": _unref(errorMessageData).phoneExistence,
                                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '단말기번호' }),
                                    maxlength: _unref(PHONE_MAX_LENGTH),
                                    rules: _ctx.formRules.phone.value,
                                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                    onBlur: onBlurPhoneField
                                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                                    (isCheckedPhoneExistence.value)
                                        ? {
                                            name: "append-inner",
                                            fn: _withCtx(() => [
                                                (_unref(errorMessageData).phoneExistence)
                                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                                        key: 0,
                                                        color: "red"
                                                    }, {
                                                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                            _createTextVNode(" mdi-close ")
                                                        ])),
                                                        _: 1 /* STABLE */,
                                                        __: [24]
                                                    }))
                                                    : (_openBlock(), _createBlock(_component_v_icon, {
                                                        key: 1,
                                                        color: "green"
                                                    }, {
                                                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                            _createTextVNode(" mdi-check ")
                                                        ])),
                                                        _: 1 /* STABLE */,
                                                        __: [25]
                                                    }))
                                            ]),
                                            key: "0"
                                        }
                                        : undefined
                                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "error-messages", "placeholder", "maxlength", "rules"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}tel_number`)
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _unref(telNumberComputed),
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (_isRef(telNumberComputed) ? (telNumberComputed).value = $event : null)),
                                    density: "compact",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    inputmode: "numeric",
                                    "validate-on": "blur",
                                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '연락처' }),
                                    maxlength: _unref(PHONE_MAX_LENGTH),
                                    rules: _ctx.formRules.telNumber.value,
                                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );"
                                }, null, 8 /* PROPS */, ["modelValue", "placeholder", "maxlength", "rules"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createCommentVNode(" 근무정보 "),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}work_time`),
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: _unref(workTimeOnComputed),
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (_isRef(workTimeOnComputed) ? (workTimeOnComputed).value = $event : null)),
                                        variant: "outlined",
                                        density: "compact",
                                        "hide-details": "auto",
                                        type: "time",
                                        suffix: _ctx.$t(`common.on`),
                                        onBlur: _cache[7] || (_cache[7] = ($event) => (onBlurWorkTimeField('on')))
                                    }, null, 8 /* PROPS */, ["modelValue", "suffix"]),
                                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mx-2" }, [
                                        _createElementVNode("span", null, "~")
                                    ], -1 /* CACHED */)),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: _unref(workTimeOffComputed),
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (_isRef(workTimeOffComputed) ? (workTimeOffComputed).value = $event : null)),
                                        variant: "outlined",
                                        density: "compact",
                                        "hide-details": "auto",
                                        type: "time",
                                        suffix: _ctx.$t(`common.off`),
                                        onBlur: _cache[9] || (_cache[9] = ($event) => (onBlurWorkTimeField('off')))
                                    }, null, 8 /* PROPS */, ["modelValue", "suffix"])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}home_address`)
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: currentAddress.value,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((currentAddress).value = $event)),
                                        placeholder: _ctx.$t(`${changePostcodeLc}search_postcode`),
                                        variant: "outlined",
                                        "hide-details": "auto",
                                        density: "compact",
                                        filled: isCurrentAddressDisabled.value,
                                        disabled: isCurrentAddressDisabled.value,
                                        maxlength: _unref(ADDRESS_MAX_LENGTH),
                                        class: "grow"
                                    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "filled", "disabled", "maxlength"]),
                                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                        "hide-details": "auto",
                                        class: "ml-2",
                                        onClick: handleClickPostcode
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                                small: "",
                                                class: "pr-1"
                                            }, {
                                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                                    _createTextVNode(" mdi-magnify ")
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [27]
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${changePostcodeLc}search_postcode`)), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })), [
                                        [
                                            _directive_btn_style,
                                            void 0,
                                            "config",
                                            {
                                                info: true,
                                                outlined: true,
                                                large: true,
                                                "size-l": true
                                            }
                                        ]
                                    ])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createCommentVNode(" [다이얼로그] 주소검색 "),
                        _createVNode(_component_v_dialog, {
                            modelValue: isPostcodeDialogOpen.value,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((isPostcodeDialogOpen).value = $event)),
                            "content-class": "responsive-dialog"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card, null, {
                                    default: _withCtx(() => [
                                        _createVNode(DialogHeader, {
                                            title: _ctx.$t(`${changePostcodeLc}search_postcode`),
                                            "on-cancel": handleClickCancelPostcode
                                        }, null, 8 /* PROPS */, ["title"]),
                                        _createElementVNode("div", {
                                            ref_key: "postcodeDialogRef",
                                            ref: postcodeDialogRef
                                        }, null, 512 /* NEED_PATCH */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"]),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}worker_type`),
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    modelValue: workerTypeComputed.value,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((workerTypeComputed).value = $event)),
                                    filled: "",
                                    disabled: "",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "auto"
                                }, null, 8 /* PROPS */, ["modelValue"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createCommentVNode(" 입사일 "),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}worker_registration_date`),
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_vue_datepicker, {
                                    class: "block",
                                    modelValue: workerRegDateRef.value,
                                    "onUpdate:modelValue": [
                                        _cache[13] || (_cache[13] = ($event) => ((workerRegDateRef).value = $event)),
                                        handleClickPickerSubmit
                                    ],
                                    "model-type": "yyyy-MM-dd",
                                    format: "yyyy-MM-dd"
                                }, {
                                    "action-row": _withCtx((rowProps) => [
                                        _createVNode(_component_vue_datepicker_action_row, _normalizeProps(_guardReactiveProps(rowProps)), null, 16 /* FULL_PROPS */)
                                    ]),
                                    "dp-input": _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                            value: _unref(formData).workerRegDate,
                                            variant: "outlined",
                                            density: "compact",
                                            readonly: "",
                                            "hide-details": "",
                                            "bg-color": "white",
                                            "prepend-inner-icon": "mdi-calendar-month-outline"
                                        }, null, 8 /* PROPS */, ["value"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}memo`)
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _unref(memoComputed),
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => (_isRef(memoComputed) ? (memoComputed).value = $event : null)),
                                    density: "compact",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    "validate-on": "blur",
                                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '메모' }),
                                    maxlength: _unref(WORKER_CREATE_MEMO_MAX_LENGTH),
                                    onBlur: onBlurMemoField
                                }, null, 8 /* PROPS */, ["modelValue", "placeholder", "maxlength"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}deposit_baromoney`),
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createCommentVNode(" 예치금 "),
                                _createVNode(_component_v_text_field, {
                                    modelValue: _unref(formattedDepositBaromoneyComputed),
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => (_isRef(formattedDepositBaromoneyComputed) ? (formattedDepositBaromoneyComputed).value = $event : null)),
                                    density: "compact",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    "validate-on": "blur",
                                    inputmode: "numeric",
                                    suffix: _ctx.$t('common.currency'),
                                    maxlength: _unref(DEPOSIT_BAROMONEY_MAX_LENGTH),
                                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                    onBlur: _cache[16] || (_cache[16] = ($event) => (onBlurDepositBaromoney(_unref(formattedDepositBaromoneyComputed))))
                                }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength"]),
                                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.lc}deposit_baromoney_info_text`)), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}withdrawal_bank`, { title: '은행' })
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_autocomplete, {
                                    "item-title": "text",
                                    "item-value": "value",
                                    modelValue: withdrawalBankCodeComputed.value,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((withdrawalBankCodeComputed).value = $event)),
                                    items: _unref(bankItems),
                                    variant: "outlined",
                                    density: "compact",
                                    placeholder: _ctx.$t('common.select_field_placeholder', { field: _ctx.$t(`common.bank`) }),
                                    "hide-details": "auto",
                                    onKeyup: _cache[18] || (_cache[18] = ($event) => ($event.stopPropagation()))
                                }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}withdrawal_bank`, { title: '계좌번호' })
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _unref(withdrawalBankAccountComputed),
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => (_isRef(withdrawalBankAccountComputed) ? (withdrawalBankAccountComputed).value = $event : null)),
                                    density: "compact",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    inputmode: "numeric",
                                    "validate-on": "blur",
                                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '계좌번호' }),
                                    maxlength: _unref(WITHDRAWAL_BANK_ACCOUNT_MAX_LENGTH),
                                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );"
                                }, null, 8 /* PROPS */, ["modelValue", "placeholder", "maxlength"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}withdrawal_bank`, { title: '예금주' })
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _unref(withdrawalBankOwnerComputed),
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => (_isRef(withdrawalBankOwnerComputed) ? (withdrawalBankOwnerComputed).value = $event : null)),
                                    density: "compact",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    "validate-on": "blur",
                                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '예금주' }),
                                    maxlength: _unref(WITHDRAWAL_BANK_OWNER_MAX_LENGTH),
                                    onBlur: onBlurWithdrawalBankOwnerField
                                }, null, 8 /* PROPS */, ["modelValue", "placeholder", "maxlength"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createCommentVNode(" 결격여부 "),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${_ctx.lc}conviction_status`),
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_radio_group, {
                                    modelValue: convictionStatusComputed.value,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((convictionStatusComputed).value = $event)),
                                    inline: "",
                                    density: "compact",
                                    "hide-details": "auto"
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(convictionStatus), (option, key) => {
                                            return (_openBlock(), _createBlock(_component_v_radio, {
                                                key: key,
                                                label: option.text,
                                                value: option.key
                                            }, null, 8 /* PROPS */, ["label", "value"]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["title"])
            ]));
        };
    }
});
